import image from "../rsc/danilo_new.jpg"

interface Person {
    firstName: string;
    lastName: string;
    image: string;
    email: string;
    website: string;
    instagram?: string;
    github?: string;
    linkedin?: string;
    xing?: string;
    medium?: string;
    city: string;
    locationHint?: string;
    state: string;
    country: string;
    preferredIdes: string[];
    favTec: string[];
    operatingSystems: string[];
    programs: string[];
    interests: string[];
    awards: string[];
    about: string[]; // Paragraphs about you
}

export const person:Person = {
    firstName: "Danilo",
    lastName: "Walenta",
    image: image,
    email: "contact@danilowalenta.com",
    website: "https://danilowalenta.com",
    github: "https://github.com/dannlos",
    linkedin: "https://www.linkedin.com/in/danilo-walenta/",
    instagram: "https://www.instagram.com/danilowalenta/",
    city: "Darmstadt",
    locationHint: "near Frankfurt",
    state: "Hesse",
    country: "Germany",
    preferredIdes: ["Ph.D. Candidate and Research Associate at **Technical University Darmstadt**"],
    favTec: ["German (native)", "English"],
    operatingSystems: ["Large Language Models (LLM)","Natural Language Processing (NLP)","Retrieval Augmented Generation (RAG)","Python","Java","HTML","Google Cloud (GCP)","Docker","git"],
    programs: ["**Team Player**","Curiosity","Analytical","Ambitious","Willingness to Learn","Efficient"],
    interests: ["Artificial Intelligence", "Habit Engineering","Home Automation", "Cycle ball","Cycling", "Sailing","YMCA", "logic games"],
    awards: ["**Winner of the the poster session** \n at AI AND HORSEPOWER: PORSCHE SYMPOSIUM FOR SCIENTIFIC AND PRACTICAL PROGRESS IN AI (06/2026)","\n**Best Paper in Minitrack** \"Metaverse for Work and Play\" and **Best HICSS 2026 Paper** Nominee \n At the 59th Hawaii International Conference on System Sciences (HICSS 2026)","\n**Hessen Idea Scholarship** \n(10/2021 - 03/2022)","\n**STEM-Award** \nFor outstanding achievements in STEM subjects (science, technology, engineering, and mathematics) (06/2016)"],
    about: ["I am Danilo Walenta, M.Sc. a doctoral researcher in Information Systems and Research Associate at the Software and AI Business Group at the Technical University of Darmstadt.",
        "My research interests include the sociotechnical effects of emergent technologies (e.g., artificial intelligence, the metaverse) on human behavior, learning, and collaboration. My focus is not on the technological capabilities of AI systems per se, but rather on their impact on humans as users, learners, and decision-makers.",
        "Driven by curiosity and a strong ability to quickly adapt to new tasks, I enjoy engaging with a wide range of challenges. Guided by the mindset, \"We will either find a way or make one,\" I approach obstacles with openness, persistence, and a solution-oriented perspective. "]
}
